/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type ProviderCategory = typeof ProviderCategory[keyof typeof ProviderCategory];


export const ProviderCategory = {
  GASTRONOMIE: 'GASTRONOMIE',
  ERLEBEN: 'ERLEBEN',
  SHOPPING: 'SHOPPING',
  SERVICES: 'SERVICES',
} as const;
